export enum ResourceActivityStatus {
  Idle = "Idle",
  EnRoute = "EnRoute",
  OnSite = "OnSite",
  OnBreak = "OnBreak",
}
